export const SCHOOL_LEVELS = [
  {
    name: "پیش دبستانی",
    value: 1,
    color: "#EA047E",
    gradeOptions: [
      { name: "پیش یک", value: -1 },
      { name: "پیش دو", value: -2 },
    ],
  },
  {
    name: "ابتدایی اول",
    value: 2,
    color: "#926DFB",
    gradeOptions: [
      { name: "اول", value: 1 },
      { name: "دوم", value: 2 },
      { name: "سوم", value: 3 },
    ],
  },
  {
    name: "ابتدایی دوم",
    value: 3,
    color: "#42855B",
    gradeOptions: [
      { name: "چهارم", value: 4 },
      { name: "پنجم", value: 5 },
      { name: "ششم", value: 6 },
    ],
  },
  {
    name: "متوسطه اول",
    value: 4,
    color: "#988F20",
    gradeOptions: [
      { name: "هفتم", value: 7 },
      { name: "هشتم", value: 8 },
      { name: "نهم", value: 9 },
    ],
  },
  {
    name: "متوسطه دوم",
    value: 5,
    color: "#FF6D28",
    gradeOptions: [
      { name: "دهم", value: 10 },
      { name: "یازدهم", value: 11 },
      { name: "دوازدهم", value: 12 },
    ],
  },
];
